module.exports = __webpack_public_path__ + "static/media/programms.78e81f0d.svg";